// One place decides who the app says the owner is.
//
// Casey, 2026-09-11: "remove Casey, my phone number, my tail number from the
// demo app too." The demo is a sales surface — a prospect must not be able to
// walk it and come away with his name, his cell, his email or his airplane.
// Everything the UI prints about the owner goes through here.
import { demoEnabled } from './demoFlag';

const DEMO = demoEnabled();

/** How the owner is addressed in copy, messages and signatures. */
export const OWNER_FIRST = DEMO ? 'Jordan' : 'Casey';
export const OWNER_NAME = DEMO ? 'Jordan Wells' : 'Casey Casburn';
/** The full legal name used in the lease and on signed PDFs. */
export const OWNER_LEGAL = DEMO ? 'Jordan A. Wells' : 'Casey William Casburn';
export const OWNER_EMAIL = DEMO ? 'info@ajmaviation.com' : 'casey@ajmaviationventures.com';
/** 555-01xx is the reserved fictional range, so a demo number can never dial a real person. */
export const OWNER_PHONE = DEMO ? '(555) 010-4477' : '949-887-6393';
/** Business mailing address. The real one is Casey's home — never show it on the demo.
 *  Matches the swap `lease.ts` makes, so the settings form and the lease agree. */
export const OWNER_ADDRESS = DEMO
  ? '1 Airport Way, Suite 100, Long Beach, CA 90808'
  : '101 Main Street STE H, Seal Beach, CA 90740';
